import { persistStore as createPersistStore, persistReducer as createPersistReducer, } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// 永続化の設定
const persistConfig = {
    key: 'proffit-mart-persist-storage',
    storage,
    whitelist: ['proffitSearch'],
};
export const persistReducer = (rootReducer) => createPersistReducer(persistConfig, rootReducer);
export const persistStore = (store, cb) => createPersistStore(store, {}, cb);
